import React from "react";
import Profile from "../components/account/Profile";
import Layout from "../components/Layout/Layout";

const Account = () => {
  return (
    <Layout>
      <Profile />
    </Layout>
  );
};

export default Account;
